module.exports = __webpack_public_path__ + "static/media/a.3a069d3e.m4a";